<template>
  <!-- eslint-disable vue/require-v-for-key, vue/no-use-v-if-with-v-for, vue/no-unused-vars -->
  <div
    :class="[{'search-appeared': display.search}]"
    style="height: 100%;"
  >
    <header class="row align-items-center no-margin">
      <div
        v-if="display.search"
        class="overlay-disabled"
        @click="setPosDisplay({search: false})"/>
      <div class="col text-white">
        {{ branch.name }}
      </div>
      <div class="col-2 d-none d-lg-block text-center">
        <img
          src="./../../../../../../assets/logo-11.png"
          style="position: relative;top: -1px;">
      </div>
      <div class="col text-right">
        <!-- <div class="dropdown show">
          <a class="btn no-bg dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-ellipsis-v"></i>
          </a>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item">
              <i class="fas fa-info"></i>
              {{ $t('message.help') }}
            </a>
            <router-link class="dropdown-item" :to="{ name: 'PosDashboard'}">
              <i class="fas fa-sign-out-alt"></i>
              {{ $t('message.exitpos', {string: $t('app.pos.title')}) }}
            </router-link>
          </div>
        </div> -->
        <div class="dropdown show">
          <vs-tooltip
            :text="$t('message.exit')"
            color="zindex-5"
            position="bottom">
            <a
              class="btn no-bg"
              @click="onBackToDashboard"
            >
              <i class="fas fa-power-off"/>
            </a>
          </vs-tooltip>
        </div>
        <div class="dropdown show">
          <vs-tooltip
            v-if="!isOffline"
            :text="bills.length > 0 ? $t('message.transactionswillsaveauto', {number: bills.length}) : networkMessage"
            color="zindex-5"
            position="bottom">
            <div
              v-if="bills.length > 0"
              class="count">
              {{ bills.length }}
            </div>
            <a
              class="btn no-bg"
              style="cursor: default;">
              <i class="fas fa-wifi"/>
            </a>
          </vs-tooltip>
          <vs-tooltip
            v-if="isOffline"
            :text="bills.length > 0 ? $t('message.transactionswillsaveauto', {number: bills.length}) : networkMessage"
            color="zindex-5"
            position="bottom">
            <a
              class="btn no-bg"
              style="cursor: default;">
              <div
                v-if="bills.length > 0"
                class="count">
                {{ bills.length }}
              </div>
              <i class="fas fa-wifi text-danger"/>
            </a>
          </vs-tooltip>
        </div>
        <!-- <div class="dropdown show">
          <a class="btn no-bg" @click="onClickSwtichLang()">
            <i class="fas fa-language" style="font-size: 18px;position: relative;top: 2px;"></i>
          </a>
        </div> -->
        <div
          v-if="posSettings.menu_online.is_active"
          class="dropdown show">
          <vs-tooltip
            :text="$t('apps.pos.message.createnewqrcode')"
            position="bottom"
            color="zindex-5"
          >
            <a
              class="btn no-bg"
              @click="handleOpenCreateQRCodeForm">
              <i
                class="fas fa-qrcode"
                style="font-size: 18px;position: relative;top: 2px;"/>
            </a>
          </vs-tooltip>
        </div>
        <div
          v-if="posSettings.menu_online.is_active"
          class="dropdown show">
          <vs-tooltip
            :text="$t('message.notifications')"
            position="bottom"
            color="zindex-5"
          >
            <BaseNotificationBell
              id="notification-bell"
              :count="unreadNotificationCount"
              @onClick="handleClickNotificationBell"
            />
          </vs-tooltip>
        </div>
        <div
          v-if="posSession"
          class="dropdown show"
          style="width: auto;">
          <a
            class="btn no-bg"
            style="cursor: default;font-size: 12px;position: relative;top: 11px;">
            <vs-tooltip
              :text="$t('apps.pos.message.possession')"
              color="zindex-5"
              style="float: left;"
              position="bottom">
              <span style="position: relative;top: -8px;">{{ posSession.ps_code }}</span>
            </vs-tooltip>
          </a>
        </div>
      </div>
    </header>

    <section class="categories-section">
      <div
        v-if="display.search"
        class="overlay-disabled"
        @click="setPosDisplay({search: false})"/>
      <ul
        class="wrapper-cat"
        col>
        <li
          v-for="(item, index) in products"
          v-if="item.productsCount > 0 || ['1', '2'].includes(item.category_id)"
          :key="index"
          :class="{active: item.category_id == category_id}"
          class="item row no-margin"
          @click="changePosCategory(item.category_id)">
          <div
            class="col-8"
            style="padding-right: 0;">
            <span v-if="item.category_id == '1'">
              <i
                class="fas fa-star"
                style="width: 18px;color: #F7A621;"/>
              {{ $t('message.favorite') }}
            </span>
            <span v-else-if="item.category_id == '2'">
              <i
                class="fas fa-cubes"
                style="width: 18px;"/>
              {{ $t('message.all') }}
            </span>
            <span v-else>
              {{ item.category_name }}
            </span>
          </div>
          <div
            class="col-4 text-right"
            style="padding-left: 0;">
            {{ item.productsCount }}
          </div>
        </li>
      </ul>
    </section>

    <section class="products-section">
      <div class="top-bar row">
        <ul
          v-if="!display.search"
          class="wrapper-viewtype col">
          <li
            :class="{ active: display.type == 'grid' }"
            class="row align-items-center"
            @click="setPosDisplay({type: 'grid'})">
            <i class="fas fa-th col"/>
          </li>
          <li
            :class="{ active: display.type == 'list' }"
            class="row align-items-center"
            @click="setPosDisplay({type: 'list'})">
            <i class="fas fa-th-list col"/>
          </li>
          <li
            v-if="showDiscountButton"
            :class="{ active: display.type == 'discount' }"
            class="row align-items-center"
            @click="setPosDisplay({type: 'discount'})">
            <i class="fas fa-tag col"/>
          </li>
        </ul>
        <div
          :class="[{'text-center': !display.search}]"
          class="row align-items-center title col">
          <template>
            <div
              v-for="(item, index) in products"
              v-if="item.category_id == category_id && !display.search"
              class="col">
              <span v-if="item.category_id == '1'">
                {{ $t('message.favorite') }}
              </span>
              <span v-else-if="item.category_id == '2'">
                <template v-if="['grid', 'list'].includes(display.type)">
                  {{ $t('apps.pos.message.allproducts') }}
                </template>
                <template v-else>
                  {{ $t('message.discount') }}
                </template>
              </span>
              <span v-else>
                {{ item.category_name }}
              </span>
              <template v-if="['grid', 'list'].includes(display.type)">
                ({{ item.productsCount }})
              </template>
              <template v-else>
                ({{ filterDiscounts.length }})
              </template>
            </div>
            <div
              v-if="display.search"
              class="col">
              {{ $t('message.resultsearch') }}: {{ resultSearchCount }}
            </div>
          </template>
        </div>
        <ul class="action col">
          <template v-if="display.type != 'discount'">
            <li
              v-if="!display.search"
              class="row align-items-center"
              @click="setPosDisplay({search: true})">
              <i class="fas fa-search col"/>
            </li>
            <li
              v-else
              class="row align-items-center">
              <div class="wp-search">
                <button
                  class="btn btn-close"
                  @click="setPosDisplay({search: false})">
                  <i class="fas fa-times"/>
                </button>
                <!-- v-on:blur="handleBlurTxtSearch()" -->
                <input
                  ref="txtfield-search"
                  :placeholder="$t('placeholder.search')"
                  v-model="txtFieldSearch"
                  type="text"
                  class="form-control form-control-sm">
              </div>
            </li>
          </template>
          <!-- <li class="row align-items-center">
            <i class="fas fa-barcode col"></i>
          </li> -->
        </ul>
      </div>
      <div
        v-if="display.type == 'grid'"
        class="container-items grid">
        <BaseNotFoundData
          v-if="notfound"
          :title="$t('apps.pos.message.notfoundproducts')"
          :detail="$t('apps.pos.message.createnewproduct')"
        />
        <div
          v-for="(item, index) in filterProducts"
          v-if="item.category_id == category_id"
          class="wrapper-items"
          style="height: 100%;">
          <RecycleScroller
            :items="item.products"
            :itemSize="gridHeight"
            :gridItems="6"
            :itemSecondarySize="gridWidth"
            keyField="product_id"
            class="scroller"
            @ready="setRecycleScrollerGridUI"
          >
            <template #default="{ item: product, index }">
              <div
                :class="[{'disabled': isSinglePriceAndIsNotAvailable(product) || isSinglePriceAndOutOfStock(product)}]"
                class="outer-item"
                style="width: 100%;"
                @click="selectedProduct(product)">
                <div class="top-bar-icon text-right">
                  <!-- not available -->
                  <template >
                    <span
                      v-if="isSinglePriceAndIsNotAvailable(product)"
                      class="badge badge-danger"
                      style="font-size: 9px;position: relative;top: -1px;">
                      {{ $t('message.productisnotavailable') }}
                    </span>
                    <span
                      v-if="isSinglePriceAndOutOfStock(product)"
                      class="badge badge-danger"
                      style="font-size: 9px;position: relative;top: -1px;">
                      {{ $t('message.outofstock') }}
                    </span>
                  </template>
                  <template>
                    <!-- Stock Balance -->
                    <vs-tooltip
                      v-if="isSyncWithWarehouse(product)"
                      :text="$t('apps.inventory.message.stockquantity').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 3px;cursor: pointer;"
                    >
                      <span
                        class="badge badge-secondary"
                        style="font-size: 12px;position: relative; top: 0px;"
                      >
                        <i
                          class="fas fa-box-open"
                          style="font-size: 12px;position: relative; top: 1px;"/>
                        {{ stockCount(product) }}
                      </span>
                    </vs-tooltip>
                    <!-- Lot -->
                    <vs-tooltip
                      v-if="
                        !isCustomAttr(product) &&
                          isProductUseLot(product)
                      "
                      :text="$t('message.chooselot').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 3px;cursor: pointer;"
                    >
                      <span
                        v-if="isSyncWithWarehouse(product)"
                        class="badge badge-secondary">
                        <i
                          class="fas fa-pallet"
                          style="font-size: 12px;position: relative; top: 1px;"/>
                      </span>
                    </vs-tooltip>
                    <!-- Serial -->
                    <vs-tooltip
                      v-if="
                        !isCustomAttr(product) &&
                          isProductUseSerial(product)
                      "
                      :text="$t('message.chooseserial').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 3px;cursor: pointer;"
                    >
                      <span
                        v-if="isSyncWithWarehouse(product)"
                        class="badge badge-secondary">
                        <i
                          class="fas fa-sd-card"
                          style="font-size: 12px;position: relative; top: 1px;"/>
                      </span>
                    </vs-tooltip>
                    <!-- Custom Price -->
                    <vs-tooltip
                      v-if="isCustomPrice(product) && !isSinglePriceAndIsNotAvailable(product) && !isSinglePriceAndOutOfStock(product)"
                      :text="$t('message.customprice').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 3px;cursor: pointer;"
                    >
                      <span class="badge badge-secondary">
                        <i
                          class="fas fa-calculator"
                          style="font-size: 12px;position: relative; top: 1px;"/>
                      </span>
                    </vs-tooltip>
                    <!-- Choose Attribute -->
                    <vs-tooltip
                      v-if="isCustomAttr(product) && !isSinglePriceAndIsNotAvailable(product) && !isSinglePriceAndOutOfStock(product)"
                      :text="$t('message.chooseattribute').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 3px;cursor: pointer;"
                    >
                      <span class="badge badge-secondary">
                        <i
                          class="fas fa-tasks"
                          style="font-size: 12px;position: relative; top: 1px;"/>
                      </span>
                    </vs-tooltip>
                  </template>
                </div>
                <div
                  :class="[{'active': isSelectedProduct(product.product_id)}]"
                  class="item col">
                  <div class="img">
                    <img
                      :src="product.images.original || defaultImages.product"
                      class="img-fluid"
                      style="width: 100%;">
                  </div>
                  <div class="name">
                    {{ product.product_name }}
                  </div>
                  <div class="hint">
                    {{ $t('message.pressentertoselect') }}
                  </div>
                </div>
              </div>
            </template>
          </RecycleScroller>
        </div>
      </div>
      <div
        v-if="display.type == 'list'"
        class="container-items list">
        <BaseNotFoundData
          v-if="notfound"
          :title="$t('apps.pos.message.notfoundproducts')"
          :detail="$t('apps.pos.message.createnewproduct')"
        />
        <ul
          v-for="(item, index) in filterProducts"
          v-if="item.category_id == category_id"
          class="wrapper-items"
          style="height: 100%;">
          <RecycleScroller
            :items="item.products"
            :itemSize="62"
            keyField="product_id"
            class="scroller"
          >
            <template #default="{ item: product, index }">
              <li
                :class="[{'disabled': isSinglePriceAndIsNotAvailable(product) || isSinglePriceAndOutOfStock(product)}]"
                class="outer-item"
                style="width: 100%;"
                @click="selectedProduct(product)">
                <div
                  :class="[{'active': isSelectedProduct(product.product_id)}]"
                  class="item col-12 row no-margin">
                  <div class="img">
                    <img
                      :src="product.images.thumbnail || defaultImages.product"
                      class="img-fluid"
                      style="width: 100%;"
                      width="48"
                      height="48">
                  </div>
                  <div class="details row no-margin align-items-center">
                    <div
                      class="text-left pname col-8"
                      style="height: 100%; display: flex; flex-direction: column; justify-content: center;"
                    >
                      <span
                        class="_pname"
                        style="float: left;margin-right: 10px;">{{ product.product_name }}</span>
                      <div>
                        <!-- Stock Balance -->
                        <vs-tooltip
                          v-if="isSyncWithWarehouse(product)"
                          :text="$t('apps.inventory.message.stockquantity').toLowerCase()"
                          position="top"
                          style="float: left;margin: 0 2px;"
                        >
                          <span
                            class="badge badge-secondary"
                            style="height: 16px; display: flex; align-items: center; justify-content: center; font-size: 9px;position: relative;top: -1px; height: 15px;margin-left: -1px;"
                          >
                            <i
                              class="fas fa-box-open"
                              style="margin-right: 2px;"/>
                            {{ stockCount(product) }}
                          </span>
                        </vs-tooltip>
                        <!-- Custom Price -->
                        <vs-tooltip
                          v-if="isCustomPrice(product) && !isSinglePriceAndIsNotAvailable(product) && !isSinglePriceAndOutOfStock(product)"
                          :text="$t('message.customprice').toLowerCase()"
                          position="top"
                          style="float: left;margin: 0 3px;cursor: pointer;"
                        >
                          <span
                            class="badge badge-secondary"
                            style="height: 16px; display: flex; align-items: center; justify-content: center; font-size: 9px;position: relative;top: -1px;height: 15px;"
                          >
                            <i class="fas fa-calculator"/>
                          </span>
                        </vs-tooltip>
                        <!-- Lot -->
                        <vs-tooltip
                          v-if="
                            !isCustomAttr(product) &&
                              isProductUseLot(product)
                          "
                          :text="$t('message.chooselot').toLowerCase()"
                          position="top"
                          style="float: left;margin: 0 2px;cursor: pointer;"
                        >
                          <span
                            v-if="isSyncWithWarehouse(product)"
                            class="badge badge-secondary"
                            style="height: 16px; display: flex; align-items: center; justify-content: center; font-size: 9px;position: relative;top: -1px;height: 15px;"
                          >
                            <i class="fas fa-pallet"/>
                          </span>
                        </vs-tooltip>
                        <!-- Serial -->
                        <vs-tooltip
                          v-if="
                            !isCustomAttr(product) &&
                              isProductUseSerial(product)
                          "
                          :text="$t('message.chooseserial').toLowerCase()"
                          position="top"
                          style="float: left;margin: 0 2px;cursor: pointer;"
                        >
                          <span
                            v-if="isSyncWithWarehouse(product)"
                            class="badge badge-secondary"
                            style="height: 16px; display: flex; align-items: center; justify-content: center; font-size: 9px;position: relative;top: -1px;height: 15px;"
                          >
                            <i class="fas fa-sd-card"/>
                          </span>
                        </vs-tooltip>
                        <!-- not available -->
                        <template>
                          <span
                            v-if="isSinglePriceAndIsNotAvailable(product)"
                            class="badge badge-danger"
                            style="font-size: 9px;position: relative;top: -1px;">
                            {{ $t('message.productisnotavailable') }}
                          </span>
                          <span
                            v-if="isSinglePriceAndOutOfStock(product)"
                            class="badge badge-danger"
                            style="font-size: 9px;position: relative;top: -1px;">
                            {{ $t('message.outofstock') }}
                          </span>
                        </template>
                      </div>
                    </div>
                    <div class="text-right price col-4">
                      <span v-if="isFixedPrice(product)">
                        {{ getNumber(product.prices[0].price) }}
                      </span>
                      <span v-else-if="isCustomPrice(product)">
                        <span class="comma">
                          {{ $t('message.variableprice') }}
                        </span>
                        <span
                          v-if="product.prices.length == 1 && product.modifiers.length > 0"
                          class="comma">
                          {{ $t('message.modifiers') }}
                        </span>
                      </span>
                      <span v-else>
                        <span
                          v-if="product.prices.length > 1"
                          class="comma">
                          {{ $t('apps.pos.message.prices', {number: product.prices.length}) }}
                        </span>
                        <span
                          v-if="product.modifiers.length > 0"
                          class="comma">
                          {{ $t('message.modifiers') }}
                        </span>
                      </span>
                    </div>
                    <div class="hint">
                      {{ $t('message.pressentertoselect') }}
                    </div>
                  </div>
                </div>
              </li>
            </template>
          </RecycleScroller>
        </ul>
      </div>
      <div
        v-if="display.type == 'discount'"
        class="container-items list">
        <ul class="wrapper-items row">
          <li
            v-for="(discount, index) in filterDiscounts"
            :key="index"
            class="outer-item col-12"
            @click="selectedDiscount(discount)"
          >
            <div
              class="item col-12 row no-margin active"
              style="height: 48px;"
            >
              <!-- <div class="img">
                <img
                  class="img-fluid"
                  style="width: 100%;"
                  width="48"
                  height="48">
              </div> -->
              <div
                class="details row no-margin align-items-center"
                style="width: 100%;"
              >
                <div
                  class="text-left pname col-8"
                  style="height: 100%; display: flex; flex-direction: column; justify-content: center;"
                >
                  <span
                    class="_pname"
                    style="float: left;margin-right: 10px;"
                  >
                    <i
                      class="fas fa-tag mr-2"
                      style="color: #6C7A86;"
                    />
                    {{ discount.discount_name }}
                  </span>
                </div>
                <div class="text-right price col-4">
                  <span v-if="discount.value_type == 'percentage'">{{ discount.value_amount }}%</span>
                  <span v-if="discount.value_type == 'number'">{{ getNumber(discount.value_amount) }} {{ currency }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="orders-section">
      <div
        v-if="display.search"
        class="overlay-disabled"
        @click="setPosDisplay({search: false})"/>
      <queuebutton-view
        v-if="use_queue"
        :loaded="loaded"
        class="btn-queue"/>
      <tablebutton-view
        v-if="use_table"
        class="btn-table"/>
      <diningbutton-view
        v-if="use_dining"
        class="btn-dining"/>
      <customerbutton-view
        v-if="user_customer"
        class="btn-customer"/>
      <orderlist-view
        class="order-list"
        disabled="false"/>
      <optionsbutton-view class="btn-options"/>
      <totalprice-view
        disabled="false"
        class="total-price"/>
    </section>

    <!-- Modal Select Lot Number -->
    <BaseSelectLotNumberModal
      :show="lotModal.show"
      :loading="lotModal.loading"
      :lots="lotList"
      :selected="lot.selected"
      :index="0"
      :skuId="lot.skuId"
      @onClose="handleCloseLotModal"
      @onCancel="handleCancleLotModal"
      @onSubmit="handleSumitLotModal"
      @onSortChange="handleSortLotChange"
    />

    <!-- Modal Select Serial Number -->
    <BaseSelectSerialNumberModal
      :show="serialModal.show"
      :loading="serialModal.loading"
      :serials="serialList"
      :selected="serial.selected"
      :index="0"
      :skuId="serial.skuId"
      @onClose="handleCloseSerialModal"
      @onCancel="handleCancleSerialModal"
      @onSubmit="handleSumitSerialModal"
      @onSortChange="handleSortSerialChange"
    />

    <!-- Notification List -->
    <BaseDropdownRich
      v-if="isShowNotificationDropdown"
      :idRef="`notification-bell`"
      :width="600"
      @onClickOutside="isShowNotificationDropdown = false"
    >
      <BaseNotificationList
        :title="$t('message.notifications')"
        :items="notifications"
        :limitItems="10"
        @onClickReadAll="handleClickReadNotifyAll"
      >
        <template #item="{ itemData: item }">
          <BaseNotificationItemApprove
            v-if="[...NEED_APPROVE_ACCESS_STATUSES, ...NEED_APPROVE_ORDERS_STATUSES].includes(item.code)"
            :code="item.code"
            :platform="item.platform"
            :dateTime="item.created_at"
            :queueNumber="item.queue_number"
            :tableNumber="item.table_number"
            :orderDetail="getNotifyDetailText(item.metadata)"
            :isRead="item.is_read"
            :responseStatus="item.metadata.responseStatus"
            @onClickReject="handleClickReject(item)"
            @onClickApprove="handleClickApprove(item)"
            @onClickViewOrderNo="handleClickViewOrderNo(item)"
          />
          <BaseNotificationItemSimple
            v-else
            :code="item.code"
            :platform="item.platform"
            :dateTime="item.created_at"
            :queueNumber="item.queue_number"
            :tableNumber="item.table_number"
            :orderDetail="getNotifyDetailText(item.metadata)"
            :isRead="item.is_read"
            @onClickRead="handleClickReadNotify(item)"
            @onClickViewOrderNo="handleClickViewOrderNo(item)"
          />
        </template>
      </BaseNotificationList>
    </BaseDropdownRich>

    <BaseBModalQRCodeForm
      :modalTitle="$t('apps.pos.message.createnewqrcode')"
      :formType="'create'"
      :isSubmitted="isSubmittedQRCodeForm"
      :branches="[branch]"
      :posSessions="[posSession]"
      :defaultValues="defaultValues"
      :qrcode="qrcode"
      @onSubmit="handleSubmitQRCodeForm"
    />

    <BaseBModalQRCodeImage
      :qrcode="qrcode"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import queuebuttonView from '@/components/apps/pos/sale/main/common/QueueButton.vue'
import tablebuttonView from '@/components/apps/pos/sale/main/common/TableButton.vue'
import diningbuttonView from '@/components/apps/pos/sale/main/common/DiningButton.vue'
import customerbuttonView from '@/components/apps/pos/sale/main/common/CustomerButton.vue'
import optionsbuttonView from '@/components/apps/pos/sale/main/common/OptionsButton.vue'
import orderlistView from '@/components/apps/pos/sale/main/common/OrderList.vue'
import totalpriceView from '@/components/apps/pos/sale/main/common/TotalPrice.vue'
import posSelectLotMixin from '@/mixins/posSelectLot'
import posSelectSerialMixin from '@/mixins/posSelectSerial'
import chooseProductMixin from '@/mixins/pos/chooseProduct'
import notificationMixin from '@/mixins/pos/notification'
import BaseNotificationBell from '../../../../../base/BaseNotificationBell.vue'
import BaseDropdownRich from '../../../../../base/BaseDropdownRich.vue'
import BaseNotificationList from '../../../../../base/BaseNotificationList.vue'
import BaseNotificationItemSimple from '../../../../../base/BaseNotificationItemSimple.vue'
import BaseNotificationItemApprove from '../../../../../base/BaseNotificationItemApprove.vue'
import BaseBModalQRCodeForm from '../../../../../base/BaseBModalQRCodeForm.vue'
import BaseBModalQRCodeImage from '../../../../../base/BaseBModalQRCodeImage.vue'

export default {
  components: {
    queuebuttonView,
    tablebuttonView,
    diningbuttonView,
    customerbuttonView,
    optionsbuttonView,
    orderlistView,
    totalpriceView,
    BaseDropdownRich,
    BaseNotificationBell,
    BaseNotificationList,
    BaseNotificationItemSimple,
    BaseNotificationItemApprove,
    BaseBModalQRCodeForm,
    BaseBModalQRCodeImage,
  },
  mixins: [chooseProductMixin, posSelectLotMixin, posSelectSerialMixin, notificationMixin],
}
</script>

<style scoped>
  .categories-section, .products-section, .orders-section {
    height: -webkit-calc(100% - 8px);
  	height:    -moz-calc(100% - 8px);
  	height:         calc(100% - 8px);
    background: #fff;
    border: solid 1px #F2F2F2;
    position: relative;
  }
  .categories-section {
    width: 178px;
    float: left;
    margin-right: 8px;
    margin-top: 8px;
  }
  .categories-section ul.wrapper-cat {
    height: 100%;
    margin-bottom: 0;
    overflow: hidden;
  }
  .categories-section ul.wrapper-cat:hover {
    overflow: auto;
  }
  .categories-section ul.wrapper-cat li.item {
    padding: 12px 0;
    cursor: pointer;
  }
  .categories-section ul.wrapper-cat li.item.active, .categories-section ul.wrapper-cat li.item:hover {
    background: var(--bg-color);
    color: #FFF;
  }
  .products-section {
    width: -webkit-calc(100% - 178px - 334px - 16px);
  	width:    -moz-calc(100% - 178px - 334px - 16px);
  	width:         calc(100% - 178px - 334px - 16px);
    float: left;
    margin-top: 8px;
  }
  .products-section .top-bar {
    margin: 0;
    border-bottom: solid 1px #F2F2F2;
    height: 48px;
  }
  .products-section .top-bar ul.wrapper-viewtype, .products-section ul.action {
    height: 100%;
    margin-bottom: 0;
    padding-left: 10px;
    padding-right: 10px;
  }
  .products-section .top-bar ul.wrapper-viewtype li, .products-section ul.action li {
    height: 100%;
    margin: 0;
    padding: 0 7.5px 0 7.5px;
    float: left;
    cursor: pointer;
  }
  .products-section ul.action li {
    float: right
  }
  .products-section .top-bar ul.wrapper-viewtype li i, .products-section ul.action li > i {
    font-size: 20px;
    color: #ddd;
    padding: 0;
  }
  .products-section .top-bar ul.wrapper-viewtype li.active i, .products-section .top-bar ul.wrapper-viewtype li:hover i,
  .products-section ul.action li.active i, .products-section ul.action li:hover i {
    color: #6C7A86;
  }
  .products-section .container-items {
    height: -webkit-calc(100% - 48px);
  	height:    -moz-calc(100% - 48px);
  	height:         calc(100% - 48px);
    overflow: auto;
  }
  .products-section .wrapper-items {
    padding: 6px 3px 0 3px;
    margin: 0;
  }
  .products-section .wrapper-items .outer-item {
    padding-left: 3px;
    padding-right: 3px;
    margin-bottom: 6px;
    position: relative;
  }
  .products-section .wrapper-items .outer-item.disabled img,
  .products-section .wrapper-items .outer-item.disabled .name,
  .products-section .wrapper-items .outer-item.disabled .pname ._pname,
  .products-section .wrapper-items .outer-item.disabled .price {
    opacity: .5;
  }
  .products-section .wrapper-items .outer-item .top-bar-icon {
    position: absolute;
    z-index: 2;
    top: 5px;
    left: 12px;
  }
  .products-section .wrapper-items .outer-item .top-bar-icon i {
    color: #FFF;
    font-size: 13px;
  }
  .products-section .wrapper-items .outer-item .item {
    padding: 0;
    cursor: pointer;
  }
  .products-section .wrapper-items .outer-item .item .hint {
    display: none;
  }
  .search-appeared .products-section .wrapper-items .outer-item .item.active {
    border: solid 3px #17a2b8;
  }
  /* .search-appeared .products-section .wrapper-items:hover .outer-item .item.active {
    border: none;
  }
  .search-appeared .products-section .wrapper-items .outer-item .item:hover {
    border: solid 3px #17a2b8 !important;
  } */
  .search-appeared .products-section .wrapper-items .outer-item .item.active .hint {
    display: block;
    position: absolute;
    background: #17a2b8;
    font-size: 11px;
    text-align: center;
    color: #fff;
    z-index: 2;
  }
  .search-appeared .products-section .container-items.grid .wrapper-items .outer-item .item.active .hint {
    bottom: 32px;
    right: 0;
    width: 100%;
  }
  .search-appeared .products-section .container-items.list .wrapper-items .outer-item .item.active .hint {
    bottom: -1px;
    right: 0;
    width: 160px;
  }
  .search-appeared .container-items.list .outer-item .item.active .details .price {
    position: relative;
    top: -6px;
  }

  .products-section .wrapper-items .outer-item .item .name {
    padding: 6px 2px 4px 6px;
    background: #fff;
    border: solid 1px #F2F2F2;
    border-top: none;
    font-size: 14px;
    text-align: center;

    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    height: auto;
    white-space: nowrap;
  }
  .orders-section {
    width: 334px;
    float: right;
    margin-left: 8px;
    margin-top: 8px;
  }
  .overlay-disabled {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 4;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.25);
  }
  .btn-table {
    position: relative;
    z-index: 3;
  }
  .container-items.list .outer-item {
    border-bottom: solid 1px #F2F2F2;
    padding: 0 3px 6px 3px;
  }
  .container-items.list .outer-item .img {
    width: 48px;
  }
  .container-items.list .outer-item .item .details {
    width: -webkit-calc(100% - 48px);
  	width:    -moz-calc(100% - 48px);
  	width:         calc(100% - 48px);
  }
  .container-items.list .outer-item .item .details .pname {
    font-size: 14px;
  }
  .container-items.list .outer-item .item .details .price {
    font-size: 14px;
  }
  header .dropdown-toggle::after {
    display: none;
  }
  header .dropdown {
    width: 46px;
    float: right;
    text-align: center;
  }
  header .dropdown a {
    color: #fff;
    position: relative;
  }
  header .dropdown a:hover {
    color: #fff;
  }
  header .dropdown a:focus {
    box-shadow: none;
  }
  header .count {
    width: 18px;
    height: 18px;
    position: absolute;
    z-index: 1;
    top: 0;
    right: 3px;
    border-radius: 100%;
    background: #dc3545;
    color: #fff;
    font-size: 9px;
    text-align: center;
    line-height: 19px;
  }
  header .dropdown .dropdown-item i {
    width: 16px;
    text-align: center;
  }
  .wp-search {
    position: relative;
  }
  .wp-search button.btn-close {
    background: none;
    position: absolute;
    top: -1px;
    right: 0;
    outline: none;
    box-shadow: none;
    color: #6C7A86;
  }
  .fas.fa-tasks {
    cursor: pointer;
  }
  .pname, .name, .price {
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }

  .scroller {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/include/ChooseProduct.vue